import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    breadcrumbsWrapper: 'relative w-full lg:mx-auto lg:max-w-360',
    breadcrumbs: 'absolute top-5 z-10 lg:top-8',
    image: 'w-full object-cover lg:h-full',
    title: 'leading-[1.2] font-semibold lg:max-w-160 lg:whitespace-pre-wrap',
    text: 'lg:whitespace-pre-wrap',
    description:
      'lg:text-m mt-2 text-xs leading-[1.4] font-light lg:mt-3 lg:leading-[1.5] lg:whitespace-pre-wrap',
    label: 'absolute -top-3 lg:relative lg:-top-2',
    button: 'inline-flex min-w-50',
    arrowPrev: 'left-10',
    arrowNext: 'right-10',
    carousel: '[--slide-size:100%]',
    banner: 'bg-blue-light relative w-full',
    wrapper: 'lg:mx-auto lg:max-w-360',
    content: '',
    dots: 'absolute right-0 left-0 mx-auto w-full lg:max-w-360',
    advertisingInformer: 'absolute top-3 right-3'
  },
  variants: {
    type: {
      main: {
        breadcrumbsWrapper: 'pl-4 lg:pl-35',
        breadcrumbs: 'left-4 lg:left-35',
        image: 'h-[250px]',
        banners: 'h-[450px] lg:h-165',
        banner: 'min-h-[450px] lg:h-165',
        title: 'pt-3 pb-0 text-2xl lg:mb-2 lg:pt-0 lg:text-5xl',
        text: 'text-sm lg:text-lg',
        button:
          'max-lg:bg-blue-dark max-lg:hover:bg-blue mt-6 max-lg:text-white lg:mt-8',
        content: 'relative p-4 lg:absolute lg:bottom-[140px] lg:ml-35 lg:px-0',
        dots: 'bottom-6 justify-end pr-4 lg:bottom-13 lg:justify-start lg:pr-0 lg:pl-35',
        arrowPrev: 'top-auto bottom-[220px]',
        arrowNext: 'top-auto bottom-[220px]',
        advertisingInformer:
          'top-20 right-3 left-auto z-10 md:top-[158px] lg:right-10'
      },
      brand: {
        breadcrumbsWrapper: 'pl-4 lg:pl-35',
        breadcrumbs: 'left-4 sm:left-6 xl:left-10',
        image: 'h-90',
        banners: 'h-90',
        banner: 'h-90',
        title: 'lg:heading-3xl md:heading-2xl heading-xl',
        text: 'text-lg',
        button: 'mt-6',
        content:
          'absolute bottom-6 max-w-[360px] px-3 md:top-1/2 md:-translate-y-1/2 md:p-4 lg:ml-28 lg:max-w-[640px] lg:px-0 xl:ml-35',
        dots: 'bottom-6 justify-end pr-3 md:pl-4 lg:pl-35',
        arrow: 'mt-4.5',
        arrowPrev: 'max-xl:left-6',
        arrowNext: 'max-xl:right-6',
        advertisingInformer: 'top-5 right-4 lg:right-10'
      },
      category: {
        breadcrumbs: 'left-5 lg:left-12',
        image: 'h-50',
        banners: 'h-45 lg:h-50',
        banner: 'h-full min-h-50',
        title: 'pb-2 text-2xl lg:text-[40px]',
        text: 'text-sm',
        content: 'absolute bottom-6 px-5 lg:ml-12 lg:px-0'
      },
      actions: {
        breadcrumbsWrapper: 'pl-4 lg:pl-35',
        breadcrumbs: 'left-4 !text-white md:!text-black lg:left-10',
        image: 'h-90',
        banners: 'h-90',
        banner: 'h-90',
        title: 'text-[32px] !text-white md:!text-black',
        text: 'text-lg !text-white md:!text-black',
        description: '!text-white md:!text-black',
        button: 'mt-6',
        content:
          'absolute bottom-6 transform px-5 md:top-1/2 md:max-w-[640px] md:-translate-y-1/2 lg:ml-35 lg:p-4 lg:px-0',
        advertisingInformer: 'top-5 right-4 lg:right-10'
      },
      'where-to-buy': {
        breadcrumbsWrapper: 'pl-4 lg:pl-35',
        breadcrumbs: 'left-4 !text-white md:!text-black lg:left-10',
        image: 'h-90',
        banners: 'h-90',
        banner: 'h-90',
        title: 'text-[32px] !text-white md:!text-black',
        text: 'text-lg !text-white md:!text-black',
        description: '!text-white md:!text-black',
        button: 'mt-6',
        content:
          'absolute top-1/2 bottom-6 -translate-y-1/2 px-5 md:max-w-[640px] md:transform lg:ml-35 lg:p-4 lg:px-0'
      }
    },
    mode: {
      light: {
        title: 'leading-[1.2] text-black',
        text: 'text-black',
        description: 'text-black'
      },
      dark: {
        breadcrumbs: 'text-white',
        title: 'leading-[1.2] text-white',
        text: 'text-white',
        description: 'text-white',
        arrowPrev: 'bg-white/10 text-white hover:opacity-70',
        arrowNext: 'bg-white/10 text-white hover:opacity-70'
      }
    }
  },
  compoundVariants: [
    {
      type: 'main',
      mode: 'dark',
      className: {
        title: 'text-black lg:text-white',
        text: 'text-black lg:text-white',
        description: 'text-black lg:text-[18px] lg:leading-[1.5] lg:text-[#fff]'
      }
    }
  ],
  defaultVariants: {
    type: 'main'
  }
});
